/******** PALETTE OF COLORS ********/

// White
export const white = '#ffffff';

// Blues
export const darkMediumBlue = '#56808e';
export const darkBlue = '#0f3e4d';
export const darkGreenBlue = '#00222d';

export const lightBlue = '#ebf2fa';
export const mediumLightBlue = '#92adcc';
export const mediumBlue = '#3493e7';
export const lightLightBlue = '#f7fafd';

// Greens
export const darkGreen = '#4e7d10';
export const mediumGreen = '#8fce3d';
export const lightGreen = '#39dc73';

// Greys
export const darkerGrey = '#222';
export const darkMediumGrey = '#506f78';
export const lightGrey = '#d7dee9';

//Reds
export const mediumRed = '#e6112b';
